angular.module('admin')
  .controller('AgentNavCtrl', ['$scope', '$state', 'AgentService', 'AccountService', 'UtilService'
    , function($scope, $state, AgentService, AccountService, utils){

    $scope.getId = function(){
      return $state.params.id;
    };

    $scope.showFullClientsNav = function(){
      return !$state.is('agent.edit') && !$state.is('agent.billing') && !$state.is('agent.share');
    };

    $scope.pageTitle = function(){
      if($state.current.data && $state.current.data.pageTitle)
        return $state.current.data.pageTitle;
      else
        return $scope.getNamePossesive() + ' Clients';
    };

    $scope.backurl = function(){
      if($state.current.data && $state.current.data.back)
        return $state.href($state.current.data.back, {id: $scope.getId()});
      else
        return false;
    };

    $scope.getAgent = function(){
      AgentService.getOne($scope.getId()).then(
        function success(data){
          $scope.agent = data;
        }, function error(err){
          utils.trackException('Admin AgentCtrl Get Agent', err);
        });
    };

    $scope.getName = function(){
      if(!$scope.agent) return '';

      if($scope.getId() === AccountService.getAgentId())
        return "You";
      else
        return $scope.agent.first_name + ' ' + $scope.agent.last_name;
    };

    $scope.getNamePossesive = function(){
      if(!$scope.agent) return '';

      if($scope.getId() === AccountService.getAgentId())
        return "Your";
      else
        return $scope.agent.first_name + ' ' + $scope.agent.last_name + '\'s';
    };

    $scope.getAgent();

  }]);
